import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./AddContentModal.css";
import Select from "react-select";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";

const options = [
  { value: "stg90", label: "STG Group" },
  { value: "boa", label: "LAB Group" },
  { value: "club84", label: "CCA Group" },
];

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    boxShadow: 'none',
    border: state.isFocused ? '1px solid #ccc' : '1px solid #ddd',
    outline: 'none',
    '&:hover': {
      border: '1px solid #aaa',
    },
  })
};

const AddContentModal = ({ isOpen, onClose, setRefreshGetContentLibrarySTGData, setRefreshGetContentLibraryBOAData, setRefreshGetContentLibraryCLUBData }) => {
  const [title, setTitle] = useState("");
  const [recordingURL, setRecordingURL] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);

  const handleThumbnailChange = (e) => {
    setThumbnail(e.target.files[0]);
  };

  const sendAddContent = async () => {
    if (!title || !recordingURL || !selectedOption) {
      toastr.error("Please fill in all fields");
      throw new Error("Please fill in all fields")
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("recording_url", recordingURL);
    formData.append("course_code", selectedOption.value);
    formData.append("thumbnail", thumbnail);

    try {
      // console.log(formData, title, recordingURL, selectedOption, thumbnail, 'formData is here....')
      const response = await apiServiceHandler("POST", "api/content/library", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      if (response.auth) {
        toastr.success(response.message);
        if (selectedOption.value == 'boa')
          setRefreshGetContentLibraryBOAData(true);
        if (selectedOption.value == 'stg90')
          setRefreshGetContentLibrarySTGData(true);
        if (selectedOption.value == 'club84')
          setRefreshGetContentLibraryCLUBData(true);
        setTitle("");
        setRecordingURL("");
        setSelectedOption(null);
        setThumbnail(null);
        onClose();
      } else {
        toastr.error(response.message || "Failed to invite user. Please try again.");
      }
    } catch (error) {
      toastr.error(error.response.data.message);
      console.error(error.response);
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>Add Content</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invite-form__fields">
          <div className="invite-form__field">
            <div className="text-input__label">Title</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                value={title}
                onChange={(e) => setTitle(e.target.value)} />
            </div>
          </div>
          <div className="invite-form__field">
            <div className="text-input__label">Recording URL</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                value={recordingURL}
                onChange={(e) => setRecordingURL(e.target.value)} />
            </div>
          </div>
          {/*
          <div className="invite-form__field">
            <div className="text-input__label">Thumbnail</div>
            <div className="form-input__wrapper">
              <input
                type="file"
                className="form-input__input"
                accept="image/*"
                onChange={handleThumbnailChange}
              />
            </div>
          </div>
          */}
          <div className="select-invite-form__field">
            <div class="select__label">Select Group</div>
            <Select
              defaultValue={selectedOption}
              onChange={setSelectedOption}
              options={options}
              placeholder=""
              styles={customStyles}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: '1rem' }}>
        <button className="add-content-btn" onClick={sendAddContent}>
          <span className="add-content-btn-label">Add Content</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddContentModal;
